import React, { useEffect, useState } from "react"
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material"
import Servo from "../../services/servo"
import Vista from "../../components/Vista"
import moment from "moment"
import dateComponent from "../../components/dateComponent"
import { LoadingButton } from "@mui/lab"

const FrecuenciaVisitas = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [fechaInicio, setFechaInicio] = useState(dateComponent.getFirstDayOfMonth())
    const [fechaFinal, setFechaFinal] = useState(dateComponent.getActualDay())
    const [busqueda, setBusqueda] = useState("")

    const getData = async () => {
        setLoading(true)
        try {
            let res = await Servo.get(`reportes/reporte-frecuencia-unidades?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}&busqueda=${encodeURIComponent(busqueda)}`)
            if (res?.cuerpo?.detalle?.datos && Array.isArray(res.cuerpo.detalle.datos)) {
                setData(res.cuerpo.detalle.datos)
            } else {
                setData([])
            }
        } catch (error) {
            console.error(error)
            setData([])
        }
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Vista>
            <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>

                <Paper elevation={3} style={{ padding: "20px" }}>
                    <h3>Filtros</h3>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="date"
                                label="Fecha Inicio"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="date"
                                label="Fecha Fin"
                                value={fechaFinal}
                                onChange={(e) => setFechaFinal(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                type="text"
                                label="Buscar (Económico o Placa)"
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "flex-end" }}>
                            <LoadingButton loading={loading} onClick={getData} variant="contained" color="primary" fullWidth>
                                Filtrar
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper elevation={3} style={{ padding: "20px" }}>
                    <h2>Reporte: Unidades con Más Ingresos al Taller</h2>

                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#157CC1" }}>
                                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Unidad (Económico)</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Marca</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Placas</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Total de Visitas</TableCell>
                                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Última Visita</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.length > 0 ? data.map((row, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell sx={{ fontWeight: "bold" }}>{row.economico || `N/A (ID: ${row.idCarro})`}</TableCell>
                                        <TableCell>{row.marca || "-"}</TableCell>
                                        <TableCell>{row.placas || "-"}</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", fontSize: "1.1em" }}>{row.total_visitas}</TableCell>
                                        <TableCell>{row.ultima_visita ? moment(row.ultima_visita).format('DD/MM/YYYY HH:mm') : "-"}</TableCell>
                                    </TableRow>
                                )) : (
                                    <TableRow><TableCell colSpan={5} sx={{ textAlign: "center" }}>No hay datos en este rango</TableCell></TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

            </div>
        </Vista>
    )
}

export default FrecuenciaVisitas
